
const options = [
    'Personality',
    'ENTP',
    'ISFP',
    'ESFJ',
    'INTJ',
    'ENFJ',
    'ISTJ',
    'ESTP',
    'INFP',
    'ENTJ',
    'ISFJ',
    'ESFP',
    'INTP',
    'ESTJ',
    'INFJ',
    'ENFP',
    'ISTP',
]

const personalities = [
    'INTJ',
    'INTP',
    'ENTJ',
    'ENTP',
    //
    'INFJ',
    'INFP',
    'ENFJ',
    'ENFP',
    //
    'ISTJ',
    'ISFJ',
    'ESTJ',
    'ESFJ',
    //
    'ISTP',
    'ISFP',
    'ESTP',
    'ESFP',
]

const introverts = [
    'ISFP',
    'INTJ',
    'ISTJ',
    'INFP',
    'ISFJ',
    'INTP',
    'INFJ',
    'ISTP',
]

const extroverts = [
    'ENTP',
    'ESFJ',
    'ENFJ',
    'ESTP',
    'ENTj',
    'ESFP',
    'ESTJ',
    'ENFP',
]
export {personalities, introverts, extroverts, options}